import React, { useEffect, useState } from 'react';
import '../../../index.scss';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import { setLoadingRedux } from 'reducers/shareData/action';
import { isType3, userTypeList } from 'main_consts';

import styled from 'styled-components';
import WarehouseModal from 'components/Modal/WareHouseModal';
import CheckBox from 'components/Material/Checkbox';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  formatDateTime,
  getDateDayPlus,
  getExpressName,
  getColWidthByField,
  getWarehouse,
  inputChange,
  radioChange,
  checkboxChange,
  initWhrehhouse,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSearch,
  snackBarRsp,
} from '../../../main_api';

import Table from '../../../components/Material/Table/index';
import { IexpNotIn, Imaster, Iresult, IresultOther } from './type';
import { Iobject } from '../../../main_type';

/** 已申報未入倉清單 */
const ExpNotInQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  const masterDefaultValue: Imaster = {
    closeMark: 'A',
    // 進出口別
    declType: '1',
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 主號
    mawbNo: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    timeCheck: '0',
    endDateValid: true,
    endTimeValid: true,
    startDateValid: true,
    startTimeValid: true,
  };
  const apiName = 'expNotInQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [rowData, setRowData] = useState<IexpNotIn[]>([]);
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [resultOther, setResultOther] = useState<IresultOther>(
    {} as IresultOther
  );

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  const DivStyle = styled.div`
    border: 3px outset #1c6ea4;
    margin-bottom: 1rem;
  `;

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getExcel(apiName, {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      mawbNo: master.mawbNo,
      closeMark: master.closeMark,
      startDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.startDate, `${master.startTime}00`),
      endDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.endDate, `${master.endTime}59`),
    });
    const startDate = formatDateTime(
      master.startDate,
      master.startTime,
      'MMdd'
    );
    const EndDate = formatDateTime(master.endDate, master.endTime, 'MMdd');

    blobDownload(
      result,
      enqueueSnackbar,
      `${
        master.chkCode1.length > 0 ? `${master.chkCode1}_` : ''
      }${startDate}_${EndDate}_已申報未入倉清單.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getSearch(apiName, {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      mawbNo: master.mawbNo,
      closeMark: master.closeMark,
      startDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.startDate, `${master.startTime}00`),
      endDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.endDate, `${master.endTime}59`),
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const data = result.data.data as Iresult;

    if (data) {
      const {
        expNotInList,
        gciPiece,
        gcoPiece,
        hawbNoCount,
        mawbNoCount,
        piece,
      } = data;
      setResultOther({
        gciPiece,
        gcoPiece,
        hawbNoCount,
        mawbNoCount,
        piece,
      });
      if ((expNotInList || []).length > 0) {
        setColList(
          getColWidthByField([
            { headerName: '項次', field: 'itemNo' },
            { headerName: '主號', field: 'mawbNo' },
            { headerName: '分號', field: 'hawbNo' },
            { headerName: '報單號碼', field: 'declNo' },
            { headerName: '申報', field: 'piece' },
            { headerName: '進倉', field: 'gciPiece' },
            { headerName: '出倉', field: 'gcoPiece' },
            { headerName: '類別', field: 'appType' },
            { headerName: '併袋號碼', field: 'expBagNo' },
            { headerName: '註記', field: 'closeMark' },
            { headerName: '海掛', field: 'vesselRegNo' },
            { headerName: '艙號', field: 'manifNo' },
            { headerName: '快遞倉站', field: 'warehouse' },
            { headerName: '報關箱號', field: 'boxNo' },
            { headerName: '貨櫃號碼', field: 'containerNo' },
          ])
        );
        setRowData(expNotInList);
        setOpenSearchTable(true);
      } else {
        setOpenSearchTable(false);
      }
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    if (master.mawbNo.length <= 0 && master.timeCheck === '0') {
      enqueueSnackbar('【主號】或【進倉日期區間】擇一必填。', {
        variant: 'warning',
      });
      return;
    }

    if (
      (master.timeCheck === '1' &&
        (!master.endDateValid ||
          !master.endTimeValid ||
          !master.startDateValid ||
          !master.startTimeValid)) ||
      !(
        master.startDate &&
        master.endTime &&
        master.startDate &&
        master.startTime
      )
    ) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">已申報未入倉清單</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 已申報未入倉清單
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進出口別：
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio"
                required
                name="declType"
                value={master.declType}
                onChange={radioChange(updateData)}
                options={[
                  { value: '1', label: '進口' },
                  { value: '2', label: '出口' },
                ]}
              />
            </VcGrid>
          </Grid>

          {/* 20210325 新增權限判斷 */}
          {userType && !isType3(userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>

              <VcGrid item xs={12} sm={3}>
                <Input
                  name="chkCode1"
                  disabled={userTypeList.type2.indexOf(userType) !== -1}
                  maxLength={4}
                  value={master.chkCode1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={3}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={3}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              主號：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                placeholder="主號或進倉日期區間擇一必填"
                maxLength={35}
                value={master.mawbNo}
                name="mawbNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              作業註記：
            </VcEGrid>
            <VcGrid item xs={12} sm={10}>
              <Radio
                className="input-radio"
                required
                name="closeMark"
                value={master.closeMark}
                onChange={radioChange(updateData)}
                options={[
                  { value: 'A', label: '全選' },
                  { value: 'N', label: '無註記(非查扣、短卸)' },
                  { value: 'Z', label: '查扣' },
                  { value: 'L', label: '短卸' },
                ]}
              />
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              日期區間：
            </VcEGrid>
            <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
              <DateTimeSePickersTyping
                key={random}
                required={master.timeCheck === '1'}
                disabled={master.timeCheck === '0'}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={[
                  ['startDate', 'startTime'],
                  ['endDate', 'endTime'],
                ]}
                data={master}
                setDayRange={7}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入時間查詢"
                checked={master.timeCheck === '1'}
                name="timeCheck"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    startDate: masterDefaultValue.startDate,
                    startTime: masterDefaultValue.startTime,
                    endDate: masterDefaultValue.endDate,
                    endTime: masterDefaultValue.endTime,
                    ...checkboxChange()(['1', '0'])(e),
                  }));
                }}
              />
            </VcGrid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <>
          <DivStyle>
            <HVcGrid container>
              <HVcGrid item xs={4} sm>
                主號： {resultOther.mawbNoCount || 0} 筆
              </HVcGrid>

              <HVcGrid item xs={4} sm>
                分號： {resultOther.hawbNoCount || 0} 筆
              </HVcGrid>

              <HVcGrid item xs={4} sm>
                申報： {resultOther.piece || 0} 件
              </HVcGrid>
              <HVcGrid item xs={4} sm>
                進倉： {resultOther.gciPiece || 0} 件
              </HVcGrid>
              <HVcGrid item xs={4} sm>
                出倉： {resultOther.gcoPiece || 0}件
              </HVcGrid>
            </HVcGrid>
          </DivStyle>
          <Table
            key={randomValue}
            data={rowData as unknown as Iobject[]}
            columns={colList}
            rowsPerPageOptions={[100, 50, 10]}
            rootProps={{ style: { height: '400px' } }}
            pageSize={100}
          />
        </>
      )}
    </div>
  );
};

export default ExpNotInQry;
